// Scrolling helpers that never move the page on phones.

/** Scrolls a scrollable container to its end (scrollIntoView would also scroll the window on small screens). */
export function scrollToEnd(el: HTMLElement | null | undefined, smooth = false): void {
  if (!el) return;
  el.scrollTo({ top: el.scrollHeight, behavior: smooth ? "smooth" : "auto" });
}

/** Autofocus only with a mouse or trackpad: on touch screens it opens the keyboard and scrolls the page. */
export function canAutoFocus(): boolean {
  return typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia("(pointer: fine)").matches;
}

/** Scrolls the nearest scrollable ancestor of `el` to its end, never the page itself (no-op when nothing scrolls). */
export function scrollNearestToEnd(el: HTMLElement | null | undefined, smooth = false): void {
  for (let p = el?.parentElement ?? null; p && p !== document.body && p !== document.documentElement; p = p.parentElement) {
    const style = getComputedStyle(p);
    if (/(auto|scroll)/.test(style.overflowY) && p.scrollHeight > p.clientHeight) {
      scrollToEnd(p, smooth);
      return;
    }
  }
}
